(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var dialog = document.getElementById('community-lightbox');
    if (!dialog) return;

    var video = dialog.querySelector('.community-lightbox__video');
    var handleEl = dialog.querySelector('.community-lightbox__handle');
    var closeBtn = dialog.querySelector('[data-lightbox-close]');

    function openLightbox(trigger) {
      var src = trigger.getAttribute('data-video-src');
      if (!src) return;
      video.querySelector('source') ? null : null;
      video.innerHTML = '';
      var sourceEl = document.createElement('source');
      sourceEl.src = src;
      sourceEl.type = 'video/mp4';
      video.appendChild(sourceEl);
      video.poster = trigger.getAttribute('data-poster') || '';
      handleEl.textContent = trigger.getAttribute('data-handle') || '';
      video.load();

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      video.play().catch(function () {});
    }

    function closeLightbox() {
      video.pause();
      video.innerHTML = '';
      video.load();
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    document.querySelectorAll('[data-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openLightbox(trigger);
      });
    });

    closeBtn.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeLightbox();
    });

    dialog.addEventListener('close', function () {
      video.pause();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var stepper = document.querySelector('.merch-product__stepper');
    if (stepper) {
      var input = stepper.querySelector('[data-quantity-input]');
      stepper.querySelector('[data-quantity-decrease]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      stepper.querySelector('[data-quantity-increase]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    }

    var form = document.querySelector('[data-product-form]');
    var errorEl = document.querySelector('[data-cart-error]');
    var variantInput = document.querySelector('[data-variant-input]');
    var quantityInput = document.querySelector('[data-quantity-input]');

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var variantId = variantInput ? variantInput.value : null;
        var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
        if (!variantId) return;

        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }],
            sections: ['cart-drawer'],
            sections_url: window.location.pathname,
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data && data.status) {
              if (errorEl) {
                errorEl.hidden = false;
                errorEl.textContent = data.description || "This product isn't available yet.";
              }
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: data } }));
            document.dispatchEvent(new CustomEvent('cart:add'));
          })
          .catch(function () {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = "This product isn't available yet.";
            }
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purchase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    // Everything below is scoped to `form`, not `document` — cart-drawer.liquid
    // reuses the same data-quantity-input/-increase/-decrease attributes for
    // its own line items, and that drawer is rendered globally on every page,
    // so an unscoped document.querySelector here would risk grabbing a cart
    // line item's quantity control instead of this form's, if the drawer
    // happens to have items in it already.
    var quantityInput = form.querySelector('[data-quantity-input]');
    var decreaseBtn = form.querySelector('[data-quantity-decrease]');
    var increaseBtn = form.querySelector('[data-quantity-increase]');
    var variantInput = form.querySelector('[data-variant-input]');
    var errorEl = document.querySelector('[data-cart-error]');

    if (decreaseBtn && quantityInput) {
      decreaseBtn.addEventListener('click', function () {
        quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
      });
    }
    if (increaseBtn && quantityInput) {
      increaseBtn.addEventListener('click', function () {
        quantityInput.value = (parseInt(quantityInput.value, 10) || 1) + 1;
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var variantId = variantInput ? variantInput.value : null;
      var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
      if (!variantId) return;

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
          sections: ['cart-drawer'],
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status) {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = data.description || "This product isn't available yet.";
            }
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: data } }));
          document.dispatchEvent(new CustomEvent('cart:add'));
        })
        .catch(function () {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = "This product isn't available yet.";
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.product-reviews');
    if (!section) return;

    var filterToggle = section.querySelector('[data-reviews-filter-toggle]');
    var filterRow = section.querySelector('[data-reviews-filter-row]');
    if (filterToggle && filterRow) {
      filterToggle.addEventListener('click', function () {
        var isHidden = filterRow.hidden;
        filterRow.hidden = !isHidden;
        filterToggle.setAttribute('aria-expanded', String(isHidden));
      });
    }

    var list = section.querySelector('[data-reviews-list]');
    var items = list ? Array.prototype.slice.call(list.querySelectorAll('.product-review')) : [];
    var activeStar = null;

    function applyFilter() {
      items.forEach(function (item) {
        var rating = parseFloat(item.getAttribute('data-rating'));
        item.hidden = activeStar !== null && Math.round(rating) !== activeStar;
      });
    }

    section.querySelectorAll('[data-reviews-filter-star]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = parseInt(btn.getAttribute('data-reviews-filter-star'), 10);
        activeStar = activeStar === value ? null : value;
        section.querySelectorAll('[data-reviews-filter-star]').forEach(function (b) {
          b.classList.toggle('is-active', parseInt(b.getAttribute('data-reviews-filter-star'), 10) === activeStar);
        });
        applyFilter();
      });
    });

    var clearBtn = section.querySelector('[data-reviews-filter-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        activeStar = null;
        section.querySelectorAll('[data-reviews-filter-star]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        applyFilter();
      });
    }

    var sortSelect = section.querySelector('[data-reviews-sort]');
    if (sortSelect && list) {
      sortSelect.addEventListener('change', function () {
        var sorted = items.slice().sort(function (a, b) {
          var ra = parseFloat(a.getAttribute('data-rating'));
          var rb = parseFloat(b.getAttribute('data-rating'));
          return sortSelect.value === 'lowest' ? ra - rb : rb - ra;
        });
        sorted.forEach(function (item) {
          list.appendChild(item);
        });
      });
    }

    var dialog = document.querySelector('[data-write-review-dialog]');
    var openBtn = section.querySelector('[data-write-review-open]');
    var closeBtn = dialog ? dialog.querySelector('[data-write-review-close]') : null;
    if (dialog && openBtn) {
      openBtn.addEventListener('click', function () {
        dialog.showModal();
      });
    }
    if (dialog && closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-recipe-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.recipe-carousel__track');
      var slides = carousel.querySelectorAll('.recipe-carousel__slide');
      var dots = carousel.querySelectorAll('[data-carousel-dot]');
      var index = 0;

      function update() {
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('recipe-carousel__dot--active', i === index);
        });
      }

      function go(newIndex) {
        index = (newIndex + slides.length) % slides.length;
        update();
      }

      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('review-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var rating = form.querySelector('[data-review-rating]');
      var title = form.querySelector('[data-review-title]');
      var main = form.querySelector('[data-review-main]');
      var likes = form.querySelector('[data-review-likes]');
      var dislikes = form.querySelector('[data-review-dislikes]');
      var bodyField = form.querySelector('[data-review-body]');
      if (!bodyField) return;

      var lines = [];
      lines.push('New in-store review submission');
      lines.push('');
      if (rating && rating.value) lines.push('Rating: ' + rating.value + '/5');
      if (title && title.value) lines.push('Title: ' + title.value);
      lines.push('');
      lines.push('Review:');
      lines.push(main ? main.value : '');
      if (likes && likes.value) {
        lines.push('');
        lines.push('What they liked:');
        lines.push(likes.value);
      }
      if (dislikes && dislikes.value) {
        lines.push('');
        lines.push('What could be better:');
        lines.push(dislikes.value);
      }

      bodyField.value = lines.join('\n');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      var daysEl = el.querySelector('[data-days]');
      var hoursEl = el.querySelector('[data-hours]');
      var minutesEl = el.querySelector('[data-minutes]');
      var secondsEl = el.querySelector('[data-seconds]');

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      var timer;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          clearInterval(timer);
          return;
        }
        daysEl.textContent = pad(Math.floor(diff / 86400000));
        hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      timer = setInterval(tick, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
